import React from 'react';
import { Box, Typography, Card, CardMedia, useTheme } from '@mui/material';

const CateringCard = ({ name, image, stats = [], links = [], minWidth = { xs: 200, sm: 240, md: 260 }, maxWidth = { xs: 1, sm: 320, md: 340 }, height = '100%' }) => {
  const theme = useTheme();
  return (
    <Card sx={{
      p: { xs: 2, sm: 3 },
      borderRadius: theme.shape.borderRadius * 2,
      boxShadow: 0,
      border: `1px solid ${theme.palette.divider}`,
      minWidth,
      maxWidth,
      height,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      bgcolor: 'background.paper',
    }} aria-label="Catering details">
      <CardMedia
        component="img"
        image={image || '/default-catering.jpg'}
        alt={name}
        sx={{ width: '100%', height: 140, objectFit: 'cover', borderRadius: theme.shape.borderRadius, mb: 1 }}
      />
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, wordBreak: 'break-word' }}>
        {name}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        {links.map((link, i) => (
          <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" style={{ color: theme.palette.text.primary }} aria-label={link.icon.props['aria-label'] || 'Catering link'}>
            {link.icon}
          </a>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
        {stats.map((stat, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 1, py: 0.5, border: `1px solid ${theme.palette.divider}`, borderRadius: theme.shape.borderRadius, fontSize: 14 }}>
            {stat.icon} {stat.value}
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default CateringCard; 